import Vue from 'vue'
import VueRouter from 'vue-router'
import {commonRouter} from "./routes"

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: commonRouter
})
Vue.use(VueRouter)

export default router
